import { useState, useEffect } from "react"
import FloatingSelect from "./FloatingSelect"
import { getEstructuras } from "../utils/dataExtractors/ecographDataExtractor"
import { useTranslation } from "react-i18next"

/**
 * Component for selecting structures in ecographic examinations.
 *
 * @param {Object} props - Component props
 * @param {string} props.selectedStructure - The currently selected structure
 * @param {Function} props.setSelectedStructure - Function to update the selected structure
 * @param {boolean} props.isLoaded - Whether the component data has been loaded
 * @returns {JSX.Element} The RequestSectionEcograph component
 */
export const RequestSectionEcograph = ({ selectedStructure, setSelectedStructure, isLoaded }) => {
  const { t } = useTranslation()
  const [estructuras, setEstructuras] = useState([])

  useEffect(() => {
    if (isLoaded) {
      const estructurasData = getEstructuras()
      setEstructuras(estructurasData)
    }
  }, [isLoaded])

  return (
    <>
      <FloatingSelect
        label={t("requestSection.selectStructure")}
        value={selectedStructure}
        onChange={(value) => {
          setSelectedStructure(value)
        }}
        options={estructuras}
        fullWidth
        onSearch={(text) => {
          const filteredEstructuras = getEstructuras().filter((e) => e.label.toLowerCase().includes(text.toLowerCase()))
          setEstructuras(filteredEstructuras)
        }}
      />
    </>
  )
}

export default RequestSectionEcograph